
import ProMarketplaceLandingPageStoreName from '@/store/pro-marketplace-home/name';
import ProServiceCard from './card';
import api from '@/utils/api';
import { Endpoints } from '@/constants/Api';

export default {
  name: 'ProMarketplaceLandingPageCardSection',
  components: {
    ProServiceCard,
  },
  data() {
    return {
      serviceCategories: [],
    };
  },
  async fetch() {
    await this.getCategories();
  },
  computed: {
    content() {
      return this.$store.state[ProMarketplaceLandingPageStoreName].cardContent;
    },
  },
  methods: {
    async getCategories() {
      this.serviceCategories = await api.get(Endpoints.GetProServiceCategories, null, {
        unauthorized: true,
      });
    },
    getCategoryId(title) {
      const category = this.serviceCategories
        .find((service) => service.name.includes(title));

      return category?.categoryId;
    },
  },
};
